import { post, } from 'utils/request';
import $api from "src/config/api.config"  

const getPromocodeList = async (params) => {
  try {
    const res = await post($api.GET_PROMO_CODE, params);
    return res.data
  } catch (error) {
    console.error('getOrdersInfo',error)
    return Promise.resolve(null)
  }
}

const getPromocodeListForService = async (params) => {
  try {
    const res = await post($api.GET_PROMO_CODE_S, params);
    return res.data
  } catch (error) {
    console.error('getOrdersInfo',error)
    return Promise.resolve(null)
  }
}

export {
  getPromocodeList, getPromocodeListForService
}